import { RxDashboard } from "react-icons/rx";
import {
  FaBlog,
  FaCog,
  FaExpand,
  FaFirstOrderAlt,
  FaPaperPlane,
  FaPiggyBank,
  FaStore,
  FaStream,
  FaUsers,
  FaUsersCog,
  FaUserShield,
  FaUserTie,
} from "react-icons/fa";

import { MdSupervisedUserCircle } from "react-icons/md";

import { AdminPrivatePaths, PrivatePaths } from "../../routes/path";
import { PiNewspaperThin } from "react-icons/pi";
import { GiPayMoney, GiNewspaper } from "react-icons/gi";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { SiTestcafe } from "react-icons/si";
import { BiSolidReport } from "react-icons/bi";
import { SiGoogleclassroom } from "react-icons/si";
import { HiNewspaper } from "react-icons/hi2";

export const userLinks = [
  {
    route: PrivatePaths.DASHBOARD,
    name: "Dashboard",
    Icon: RxDashboard,
    allowed: ["SuperAdmin", "Admin", "Growth", "Partner", "Investor"],
    className: "dashboard-step-1",
  },
  {
    route: "/app/assessment",
    name: "Assessment",
    Icon: SiTestcafe,
    allowed: ["Investor"],
    className: "assessment-step-2",
  },
  {
    route: "#",
    name: "Assessment",
    Icon: SiTestcafe,
    allowed: ["SuperAdmin", "Admin", "Growth"],
    className: "assessment-step-2",
    children: [
      {
        route: "/app/assessment",
        name: "Start Assessment",
        Icon: SiTestcafe,
        allowed: ["SuperAdmin", "Admin", "Growth", "Investor"],
      },
      {
        route: "/app/assessment/report",
        name: "Assessment Report",
        Icon: BiSolidReport,
        allowed: ["SuperAdmin", "Admin", "Growth", "Investor"],
      },
    ],
  },
  {
    route: "/app/investmentReady",
    name: "Get Investment Ready",
    Icon: SiTestcafe,
    allowed: ["SuperAdmin", "Admin", "Growth"],
    className: "investment-ready-step-3",
  },
  // {
  //   route: "/app/accountability",
  //   name: "Accountability Journey",
  //   Icon: FaPaperPlane,
  //   allowed: ["SuperAdmin", "Admin", "Growth", "Investor", "Partner"],
  // },
  {
    route: AdminPrivatePaths.TRAINING,
    name: "Training",
    Icon: SiGoogleclassroom,
    allowed: ["SuperAdmin", "Admin", "Growth"],
    className: "training-step-4",
  },
  {
    route: "/app/investors",
    name: "Investors",
    Icon: FaUserTie,
    allowed: ["SuperAdmin", "Admin"],
    className: "investors-step-6",
  },
  {
    route: "/app/users",
    name: "Users",
    Icon: FaUsers,
    allowed: ["Growth"],
    className: "users-step-5",
  },
];

export const onBoardingLinks = [
  {
    route: PrivatePaths.DASHBOARD,
    name: "Dashboard",
    Icon: RxDashboard,
    allowed: ["SuperAdmin", "Admin", "Growth"],
  },
];

export const adminLinks = [
  {
    route: PrivatePaths.DASHBOARD,
    name: "Dashboard",
    Icon: RxDashboard,
    allowed: ["SuperAdmin", "Admin", "Growth"],
  },
  // {
  //   route: "/app/accountability/admin",
  //   name: "Accountability Journey",
  //   Icon: FaPaperPlane,
  //   allowed: ["SuperAdmin", "Admin"],
  // },
  {
    route: "#",
    name: "Configuration",
    Icon: FaCog,
    allowed: ["SuperAdmin", "Admin", "Growth"],
    children: [
      {
        route: AdminPrivatePaths.CATEGORY,
        name: "Assessment Category",
        Icon: FaStream,
        allowed: ["SuperAdmin", "Admin", "Growth"],
      },
      {
        route: AdminPrivatePaths.ASSESSMENT,
        name: "Assessment",
        Icon: FaExpand,
        allowed: ["SuperAdmin", "Admin", "Growth"],
      },
      // {
      //   route: AdminPrivatePaths.QST,
      //   name: "Onboarding Questionnaire",
      //   Icon: FaHandHolding,
      //   allowed: ["SuperAdmin", "Admin", "Growth"],
      // },
      {
        route: AdminPrivatePaths.COLOR,
        name: "Color",
        Icon: FaFirstOrderAlt,
        allowed: ["SuperAdmin", "Admin", "Growth"],
      },
    ],
  },

  {
    route: "#",
    name: "User Accounts",
    Icon: FaUsersCog,
    allowed: ["SuperAdmin", "Admin", "Growth"],
    children: [
      {
        route: AdminPrivatePaths.ADMIN,
        name: "Admin",
        Icon: FaUserShield,
        allowed: ["SuperAdmin", "Admin", "Growth"],
      },
      {
        route: AdminPrivatePaths.GROWTH,
        name: "Growth",
        Icon: FaUsers,
        allowed: ["SuperAdmin", "Admin", "Growth"],
      },

      {
        route: "/app/investor",
        name: "Investor",
        Icon: FaUserTie,
        allowed: ["SuperAdmin", "Admin", "Growth"],
      },
      {
        route: "/app/partner",
        name: "Partner",
        Icon: MdSupervisedUserCircle,
        allowed: ["SuperAdmin", "Admin", "Growth"],
      },
    ],
  },

  {
    route: "/app/courses",
    name: "Training",
    Icon: AiOutlineFundProjectionScreen,
    allowed: ["SuperAdmin", "Admin", "Growth", "Partner", "Investor"],
    // children: [
    //   {
    //     route: "/app/courses",
    //     name: "Training",
    //     Icon: AiOutlineFundProjectionScreen,
    //     allowed: ["SuperAdmin", "Admin", "Growth", "Partner", "Investor"],
    //   },
    //   {
    //     route: "/app/courses",
    //     name: "Courses",
    //     Icon: AiOutlineFundProjectionScreen,
    //     allowed: ["SuperAdmin", "Admin", "Growth", "Partner", "Investor"],
    //   },
    // ],
  },
  {
    route: "#",
    name: "Groups",
    Icon: FaUsers,
    allowed: ["SuperAdmin", "Admin"],
    children: [
      {
        route: "/app/batch",
        name: "Batch",
        Icon: AiOutlineFundProjectionScreen,
        allowed: ["SuperAdmin", "Admin", "Growth", "Partner", "Investor"],
      },
      {
        route: "/app/team",
        name: "Team",
        Icon: AiOutlineFundProjectionScreen,
        allowed: ["SuperAdmin", "Admin", "Growth", "Partner", "Investor"],
      },
    ],
  },
  {
    route: "/app/transaction",
    name: "Transactions",
    Icon: FaPiggyBank,
    allowed: ["SuperAdmin", "Admin", "Growth"],
  },
  // {
  //   route: "/app/blog",
  //   name: "Blog",
  //   Icon: FaBlog,
  //   allowed: ["SuperAdmin", "Admin", "Growth", "Partner", "Investor"],
  // },

  // {
  //   route: "/#",
  //   name: "Research  & Trends",
  //   Icon: HiNewspaper,
  //   allowed: ["SuperAdmin", "Admin", "Growth", "Partner", "Investor"],
  //   children: [
  //     {
  //       route: "/app/research/dailyUpdates",
  //       name: "Daily Updates",
  //       Icon: PiNewspaperThin,
  //       allowed: ["SuperAdmin", "Admin", "Growth", "Partner", "Investor"],
  //     },
  //     {
  //       route: "/app/research/report",
  //       name: "Market Analysis Report",
  //       Icon: GiNewspaper,
  //       allowed: ["SuperAdmin", "Admin", "Growth", "Partner", "Investor"],
  //     },
  //     {
  //       route: "/app/research/newsletter",
  //       name: "Newsletter",
  //       Icon: GiPayMoney,
  //       allowed: ["SuperAdmin", "Admin", "Growth", "Partner", "Investor"],
  //     },
  //   ],
  // },
];
